/** @license @dairyfarm/eval-web v3.0.0
* Copyright 2020 Texas A&M Center for Applied Technology,
* Texas A&M Engineering Experiment Station, The Texas A&M
* University System.
*
* This source code/schema and any derivative work is Texas
* A&M Engineering Experiment Station intellectual property
* and protected by copyright law. Usage is restricted solely
* to the FARM Animal Care and Environmental Stewardship
* programs administered by the National Milk Producers
* Federation. Dissemination of this source code and/or
* derivative work creation is strictly prohibited without
* express written permission from the Texas A&M Engineering
* Experiment Station.
*/
export interface Config {
  dfdmHost: string;
  oauth: {
    client_id: string;
    client_secret: string;
    redirect_uri: string;
  };
  versionMapping: { [key: string]: { min: number, maxAge: number, postPublishLockInterval: number } };
}

// Pulls information from .env file
export const appVersion = process.env.REACT_APP_VERSION;
export const helpUrl = process.env.REACT_APP_HELP_URL;

console.log(`App Version: ${appVersion}`);
console.log(`Help URL: ${helpUrl}`);

/**
 * Specify any major versions that are no longer supported. This prevents the memory used by the redux store from exploding.
 */
const VERSION_MAPPING = {
  'farm_ac_v5': {
    min: 0,
    maxAge: 90,
    postPublishLockInterval: -1
  },
  'farm_ac_v4': {
    min: 11,
    maxAge: 90,
    postPublishLockInterval: -1
  },
  'farm_ac_v4_verify': {
    min: 5,
    maxAge: 90,
    postPublishLockInterval: -1
  },
  'farm_ac_v3_verify': {
    min: 1,
    maxAge: 90,
    postPublishLockInterval: -1
  },
  'farm_es_v2_evaluator': {
    min: 0,
    maxAge: -1,
    postPublishLockInterval: -1
  },
  'farm_es_v2_self': {
    min: 1,
    maxAge: 90,
    postPublishLockInterval: -1
  },
  'wfd': {
    min: 0,
    maxAge: 90,
    postPublishLockInterval: -1
  },
  'biosecurity': {
    min: 0,
    maxAge: 90,
    postPublishLockInterval: -1
  },
  'ac_lol_pilot': {
    min: 0,
    maxAge: 90,
    postPublishLockInterval: 7
  },
  'mcap': {
    min: 0,
    maxAge: 90,
    postPublishLockInterval: -1
  },
  'cip': {
    min: 0,
    maxAge: 90,
    postPublishLockInterval: -1
  },
  'iap': {
    min: 0,
    maxAge: 90,
    postPublishLockInterval: -1
  },
  'wmp_audit': {
    min: 0,
    maxAge: 90,
    postPublishLockInterval: -1
  },
}

const configs: { [environment: string]: Config } = {
  production: {
    dfdmHost: "/dfdm",
    oauth: {
      client_id: "cd3df99b-8f63-445d-9c83-8ef0679123ae",
      client_secret: "1Rqc4wtzfynJfSl3yS2lTbZPpNDQPJ4PIPznyXn3ypI",
      redirect_uri: "/eval/"
    },
    versionMapping: VERSION_MAPPING
  },
  development: {
    dfdmHost: "http://localhost:8000",
    oauth: {
      client_id: "cd3df99b-8f63-445d-9c83-8ef0679123ae",
      client_secret: "1Rqc4wtzfynJfSl3yS2lTbZPpNDQPJ4PIPznyXn3ypI",
      redirect_uri: "http://localhost:3000/",
    },
    versionMapping: VERSION_MAPPING
  },
};

const config = configs[process.env.NODE_ENV!];

export default config;
